export default __webpack_public_path__ + "static/media/PDP-EP18-Bag.35497c07.jpg";